import DOMPurify from 'dompurify';

const defaultOptions = {
  ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'br', 'div', 'span'],
  ALLOWED_ATTR: ['href', 'class', 'style'],
};

export const sanitizeHtml = (dirty: string) => ({
  __html: DOMPurify.sanitize(dirty, defaultOptions),
});
